export default __webpack_public_path__ + "static/media/step_A_UA.1952ffc9.png";